export class DashboardHistoricalHtml {
    historicalskin () {
        return `
            <div class="container-layout full-height has-aside">
                <div class="container-column is-aside bg-subcontainer w-aside-default">
                    <div class="column-header has-menu">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Browse Tags</h3>
                        </div>
                        <div class="column-header-menu">
                            <button><span class="iconify" data-icon="ic:baseline-refresh"></span></button>
                            <button><span class="iconify" data-icon="line-md:arrow-close-left"></span></button>
                        </div>
                    </div>
                    <div class="container-body directory-view">
                        <ul class="directory-list" role="tree">
                            <li class="has-directory" role="treeitem" aria-expanded="false">
                                <div class="directory-header" tabindex="0">
                                    <span class="arrow iconify" data-icon="nrk:arrow-dropdown"></span>
                                    <span class="iconify" data-icon="proicons:folder"></span>
                                    <span class="directory-name">dbvetra</span>
                                </div>
                                <ul class="sub-directory" role="group">
                                <!-- items here, could be .has-directory again, or normal file item -->
                                    <!-- <li class="file-item" role="treeitem">
                                        INV 1
                                    </li> -->
                                    <li class="has-directory" role="treeitem" aria-expanded="false">
                                        <div class="directory-header" tabindex="0">
                                        <span class="icon folder-icon"></span>
                                        <span class="arrow iconify" data-icon="nrk:arrow-dropdown"></span>
                                        <span class="directory-name">Inverters</span>
                                        </div>
                                        <ul class="sub-directory" role="group">
                                        <!-- deeper levels -->
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="date-selector">
                            <input type="date" id="start-date" name="start-date">
                            <span class="iconify" data-icon="mdi:arrow-right-bold"></span>
                            <input type="date" id="end-date" name="end-date">
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="tag-historical-chart"></div>
                    </div>
                </div>
            </div>
        `;
    }
}